import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_ANALYTICS_PROCEDURE_QUERY_KEY } from "../types/CommonTypes";

async function getAnalyticsProcedure(
  tenantId: string,
  hospitalId: string,
  queryString: string
) {
  const { data } = await fetcher({
    url: `analytics/case-count/procedure?${queryString}`,
    method: "GET",
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

function useGetAnalyticsProcedureQuery(
  tenantId: string,
  hospitalId: string,
  queryString: string = ""
) {
  return useQuery({
    queryKey: [
      GET_ANALYTICS_PROCEDURE_QUERY_KEY,
      queryString,
      tenantId,
      hospitalId,
    ],
    queryFn: () => getAnalyticsProcedure(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
  });
}

export default useGetAnalyticsProcedureQuery;
